import { useEffect, useState } from 'react';

interface Props {
  avatarUrl?: string;
  name?: string;
  className: string;
}

/**
 * 榜单员工头像：优先展示 avatarUrl（后端返回的 OSS 签名地址），
 * 图片加载失败（如用户从未上传过头像）或无地址时回退姓名首字。
 */
export default ({ avatarUrl, name, className }: Props) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [avatarUrl]);

  if (avatarUrl && !failed) {
    return (
      <img
        className={`rank-avatar ${className}`}
        src={avatarUrl}
        alt={name || '员工头像'}
        onError={() => setFailed(true)}
      />
    );
  }

  if (!name) {
    return null;
  }

  return (
    <span className={`rank-avatar rank-avatar-fallback ${className}`}>
      {name.slice(0, 1)}
    </span>
  );
};
